/* override functions api.jquery.js */
shop_domain = location.origin || "https://schifferbooks.com"
Shopify.getCart = function(r) {
    jQuery.getJSON(shop_domain + "/cart.json?callback=?", function(t) {
        "function" == typeof r ? r(t) : Shopify.onCartUpdate(t)
    })
}

Shopify.onItemAdded = function(line_item, cart = null) {
  cart != null ? Shopify.onCartUpdate(cart) : Shopify.getCart()
};

Shopify.onCartUpdate = function(cart) {
  Shopify.cartUpdateInfo(cart, '.single-cart-item-loop');
  $('.cart-active .cart-count').text(cart.item_count);
};

Shopify.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    var str = data.description;
  } else {
   	var str = 'Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.';
  }
  jQuery('.error_message').text(str);
  jQuery('#modalAddToCartError').modal("toggle");
  setTimeout(function () {
  	jQuery('.shopping__cart').removeClass("shopping__cart__on");
    jQuery('.body__overlay').removeClass("is-visible");
  },2000);
}

Shopify.addItem = function(variant_id, quantity, callback) {
  var quantity = quantity || 1;
  var params = {
    type: 'POST',
    url: shop_domain + '/cart/add.js',
    data: 'quantity=' + quantity + '&id=' + variant_id,
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item);
      }
      else {
        Shopify.cartPopap(variant_id);
        Shopify.onItemAdded(line_item);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  
  if('https://' + location.host == shop_domain)
    jQuery.ajax(params);
  else {
  	$.ajax({ 
      dataType:'jsonp', 
      url: shop_domain + '/cart/add.json?quantity=' + quantity +'&id=' + variant_id +'&callback=apiCallback', //?
      crossDomain: true,
      jsonpCallback: 'apiCallback',
      success: function(data){ 
        /* do something with the data. In this example we are just loggin it */
        console.log(data.responseJSON||data);
        
//         $.getJSON(shop_domain + '/cart.json?callback=?', function(cart) {
//           console.log(cart);
//           $('.cart-active .cart-count').text(cart.item_count);
//         });
        
        if ((typeof callback) === 'function') {
          callback(data.responseJSON||data);
        }
        else {
          Shopify.cartPopap(variant_id);
          Shopify.onItemAdded(data.responseJSON||data);
        }
      } 
    });
  }
};

Shopify.addItemFromForm = function(form_id, variant_id, callback) {
    var params = {
      type: 'POST',
      url: '/cart/add.js',
      beforeSend: function(){
        if(form_id == "add-item-qv") {
          jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_wait").html());
        }
      },
      data: jQuery('#' + form_id).serialize(),
      dataType: 'json',
      success: function(line_item) {
        if ((typeof callback) === 'function') {
          callback(line_item);
        }
        else {
          if(form_id != "add-item-qv") {
            Shopify.cartPopapForm(variant_id);
          } else {
          	jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_added").html());
            jQuery('#' + form_id).find(".addtocartqv").addClass("added_in_cart");
            setTimeout(function(){
              	jQuery('#' + form_id).find(".addtocartqv").removeClass("added_in_cart");
            	jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
            }, 2000);
          }
          Shopify.onItemAdded(line_item);
        }
      },
      error: function(XMLHttpRequest, textStatus) {
        if(form_id != "add-item-qv") {
          Shopify.onError(XMLHttpRequest, textStatus);
        } else {
          jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_error").html());
          jQuery('#' + form_id).find(".addtocartqv").addClass("error_in_cart");
          setTimeout(function(){
            jQuery('#' + form_id).find(".addtocartqv").removeClass("error_in_cart");
            jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
          }, 2000);
        }
        Shopify.onItemAdded(line_item);
      }
    };
  
    if('https://' + location.host == shop_domain)
      jQuery.ajax(params);
    else {
      quantity = jQuery('#' + form_id).find('[name="quantity"]').val();
      variant_id = jQuery('#' + form_id).find('[name="id"]').val();
      $.ajax({ 
        dataType:'jsonp', 
        beforeSend: function(){
          if(form_id == "add-item-qv") {
            jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_wait").html());
          }
        },
        url: shop_domain + '/cart/add.json?quantity=' + quantity +'&id=' + variant_id +'&callback=?', 
        success: function(data){ 
          /* do something with the data. In this example we are just loggin it */
          console.log(data.responseJSON);
          
          if ((typeof callback) === 'function') {
            callback(data.responseJSON);
          }
          else {
            if(form_id != "add-item-qv") {
              Shopify.cartPopapForm(variant_id);
            } else {
              jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_added").html());
              jQuery('#' + form_id).find(".addtocartqv").addClass("added_in_cart");
              setTimeout(function(){
                  jQuery('#' + form_id).find(".addtocartqv").removeClass("added_in_cart");
                  jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
              }, 2000);
            }
            Shopify.onItemAdded(data.responseJSON);
          }
        },
        error: function(XMLHttpRequest, textStatus) {
          console.log(data.responseJSON);
          
          if(form_id != "add-item-qv") {
            Shopify.onError(XMLHttpRequest, textStatus);
          } else {
            jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_error").html());
            jQuery('#' + form_id).find(".addtocartqv").addClass("error_in_cart");
            setTimeout(function(){
              jQuery('#' + form_id).find(".addtocartqv").removeClass("error_in_cart");
              jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
            }, 2000);
          }
          Shopify.onItemAdded(line_item);
        }
      });
    }
};

/* user functions */

Shopify.addItemFromFormStart = function(form, product_id) {
  Shopify.addItemFromForm(form, product_id);
}

Shopify.cartPopap = function(variant_id) {
  	var image = jQuery('.'+variant_id+':first .popup_cart_image').attr("src");
  	var title = jQuery('.'+variant_id+':first .popup_cart_title').text();
  	jQuery('.popupimage').attr("src",''+image+'');
  	jQuery('.productmsg').text(''+title+'');  
  	jQuery('#modalAddToCart').modal("toggle");
}
Shopify.cartPopapForm = function(variant_id) {
  	var image = jQuery('.product_variant_image').attr("src");
  	var title = jQuery('#popup_cart_title').text();
  	jQuery('.popupimage').attr("src",''+image+'');
	jQuery('.productmsg').text(''+title+'');
	jQuery('#modalAddToCart').modal("toggle");
}

Shopify.cartUpdateInfo = function(cart, cart_cell_id) {
  var formatMoney = "<span class='money'>${{amount}}</span>";
  if ((typeof cart_cell_id) === 'string') {
    var cart_cell = jQuery(cart_cell_id);
    if (cart_cell.length) {

      cart_cell.empty();

  
      jQuery.each(cart, function(key, value) {
        if (key === 'items') {
          
          if (value.length == 1) {
            jQuery(".single-product-cart, .item-single-item-count").css({"display": "block"});
            jQuery(".cart-empty-title, .item-multiple-item-count").css({"display": "none"});
            
            var table = jQuery(cart_cell_id);
            jQuery.each(value, function(i, item) {
              if(i > 19){
                  return false;
              }
              jQuery('<li class=""><div class="cart-img"><a href="' + item.url + '"><img src="' + item.image + '" alt=""></a></div><div class="cart-title"><h4><a href="' + item.url + '">' + item.title + '</a></h4><span> ' + item.quantity + ' × ' + Shopify.formatMoney(item.price, formatMoney) + '</span></div><div class="cart-delete"><a href="javascript:void(0);" onclick="Shopify.removeItem(' + item.variant_id + ')">×</a></div></li>').appendTo(table);
            });
          }			
          else if (value.length) {
            jQuery(".single-product-cart, .item-multiple-item-count").css({"display": "block"});
            jQuery(".cart-empty-title,  .item-single-item-count").css({"display": "none"});
            
            var table = jQuery(cart_cell_id);
            jQuery.each(value, function(i, item) {
              if(i > 19){
                  return false;
              }
              jQuery('<li class=""><div class="cart-img"><a href="' + item.url + '"><img src="' + item.image + '" alt=""></a></div><div class="cart-title"><h4><a href="' + item.url + '">' + item.title + '</a></h4><span> ' + item.quantity + ' × ' + Shopify.formatMoney(item.price, formatMoney) + '</span></div><div class="cart-delete"><a href="javascript:void(0);" onclick="Shopify.removeItem(' + item.variant_id + ')">×</a></div></li>').appendTo(table);
            });
          }
          else {
            jQuery(".single-product-cart, .item-single-item-count").css({"display": "none"});
            jQuery(".cart-empty-title").css({"display": "block"});
          }
        }
      });

      
    }
  }

  changeHtmlValue(".shopping-cart__total", Shopify.formatMoney(cart.total_price, formatMoney));
  changeHtmlValue(".bigcounter", cart.item_count);

  jQuery('.currency .active').trigger('click');
}

if('https://' + location.host != shop_domain) {
  $(document).ready(function(){
    Shopify.getCart();
  });
}

//Utils
function changeHtmlValue (cell, value) {
  var $cartLinkText = jQuery(cell);
  $cartLinkText.html(value);
};